/* 루미나 화면 층 신작 — 블랙 HomePage.jsx 의 히어로 슬라이더(.black-hero) 를 시안 "고정(pin) + 스크롤 스크럽 카드 열차"로 그린다.
   데이터·상태는 전부 부모(HomePage)의 것이다(현재 장 activeIndex·이동). 이 부품은 표현과 움직임만 맡는다.
   [2026-09-28 운영자 지시] 첫 화면 카드 = 관리자 디자인설정 > 루미나 > "첫 화면 카드"에서 운영자가 고른 카드만(관리자 = 화면 1:1).
     cards 항목(부모가 만든 표시용 값): { key, kind:'event'|'game'|'provider', bg:{src, video}|null, chr:{src, fallback}|null, title }
     headline: 루미나 전용 '첫 화면 제목'(디자인 토큰). 카드 유무와 상관없이 값이 있을 때만 그린다.
   [2026-09-28 움직임 정리 — 운영자 "자연스럽지 못하고 통통 튕긴다", 실측 근거]
     ① 입장 동작은 한 번만 — 종전에는 카드 수가 바뀔 때마다(자료가 따로 도착) 줄 전체가 오른쪽으로 되돌아갔다 다시 들어왔다(한 프레임 550~744px).
     ② 자동 넘김(5초)·끝에서 처음으로 되감기 없음 — 시안·참조 사이트처럼 스크롤할 때만 움직인다(되감기는 5칸을 0.93초에 휙 되돌렸다).
     ③ 현재 장이 바뀔 때(이벤트 카드를 누르면 그 칸으로)는 부드러운 가속·감속(ease-in-out) — 종전 급출발 곡선은 첫 프레임에 툭 튀어 나갔다.
   [2026-09-29 운영자 지시] 카드 줄 아래 이전/다음 화살표·점 줄을 없앴다 — 카드는 스크롤로 움직이고, 누르면 부모가 정한 동작을 한다.
     ④ 스크롤 따라가기 — 카드는 실제 스크롤 위치를 곧장 옮기지 않고 스프링으로 뒤따라 미끄러진다(springStep, 운영자 "더 부드럽고 자연스럽게").
   WHY: SPEC §2 — 시안 JS(buildPath·pointAt·layoutHero·measureHero·heroScroll·intro)를 useEffect+ref 로 옮긴 것. */
import React, { useEffect, useRef } from 'react';
import { IconBtn, prefersReducedMotion, onEnterOrSpace, onThumbError } from './homeShared';

/* 시안 실측 기하 — 베지어 경로(참조 SVG M1 555 C1945.91 -174.366 3033.57 -192.909 4968 555), 폭 5232px@1440,
   카드 간격 = 호길이의 10%, 고정 구간(뷰포트 높이 절반) 동안 4칸 전진, 헤드라인은 1→1.5배 확대·소멸 */
const HERO = { P: [[1, 555], [1945.91, -174.366], [3033.57, -192.909], [4968, 555]], VBW: 4969, SVGW: 5232, START: 0.5, STEP: 0.1, ADVANCE: 4 };
const kf = () => Math.min(1.15, Math.max(0.42, window.innerWidth / 1440));
/* 칸 이동 시간 — 급출발 없이 가속·감속하는 곡선(ease-in-out cubic)과 함께 쓴다 */
const MOVE_MS = 800;
const easeInOutCubic = (u) => (u < 0.5 ? 4 * u * u * u : 1 - Math.pow(-2 * u + 2, 3) / 2);
/* 한 프레임에 진행하는 최대 시간(ms) — 화면 갱신이 멈췄다 풀리면(실측 200~1,800ms) 그만큼을 한 프레임에 건너뛰어 카드가 순간이동했다.
   멈춘 시간은 버리고 최대 50ms 씩만 진행해, 멈춤 뒤에도 멈췄던 자리에서 이어서 부드럽게 움직이게 한다. */
const MAX_FRAME_STEP_MS = 50;
/* [2026-09-29 운영자 "스크롤에 따른 슬라이드를 더 부드럽고 자연스럽게"] 카드 줄은 실제 스크롤 위치를 곧장 옮기지 않고
   임계 감쇠 스프링으로 뒤따른다 — 천천히 출발해 천천히 서고, 넘치지(되돌아오지) 않는다.
   WHY: ① 스크롤 위치를 그대로 옮기면 마우스 휠 한 칸(100px)마다 카드가 한 프레임에 최대 501px(1440 화면)·215px(390 폰)를
          한 번에 건너뛰었다(실측).
        ② 남은 거리의 일정 비율씩 따라가는 방식(1차 따라가기)도 휠을 굴리는 순간 속도가 0 에서 최고로 한 번에 뛰어
          급출발했다(실측 보통 프레임에서도 한 프레임 197px, 프레임 간 속도 변화 최대 6px/ms). 스프링은 속도가 이어진다.
   SCROLL_SMOOTH_TIME_S = 스프링이 목표에 다가가는 시간(초) — 0.2 면 약 0.5초에 95% 도착(1차 따라가기 160ms 와 같은 도착 시간).
   SCROLL_SETTLE_PX / SCROLL_SETTLE_SPEED = 남은 거리·속도가 둘 다 이보다 작으면 목표에 맞추고 멈춘다(가만있을 때는 계산을 돌리지 않는다). */
/* [2026-09-30 운영자 "사이트 접속시 왜 느린거야?" → 진행] 첫 화면 카드가 나타나는 연출 시간을 줄였다(동작 모양은 시안 그대로).
   WHY: 카드가 준비된 뒤에도 한가해질 때까지 최대 0.8초 기다리고, 1.4초 동안 밀려 들어와(여기에 CSS 나타나기 0.9초) 제자리에 서기까지
        2초 넘게 걸렸다(실측 카드 생성 3.4초 → 제자리 약 5.1초). 멈춤 뒤 순간이동은 한 프레임 상한(MAX_FRAME_STEP_MS)이 이미 막으므로
        한가함 대기는 짧게만 둔다. 나타나기 시간은 styles/lumina.css 의 .train 전환(0.4초)과 짝이다.
   INTRO_MS = 입장 동작 길이, INTRO_IDLE_WAIT_MS = 입장 시작 전 브라우저가 한가해지기를 기다리는 최대 시간 */
const INTRO_MS = 900;
const INTRO_IDLE_WAIT_MS = 200;
const SCROLL_SMOOTH_TIME_S = 0.2;
const SCROLL_SETTLE_PX = 0.5;
const SCROLL_SETTLE_SPEED = 10; // px/초
/* 임계 감쇠 스프링 한 걸음 — 위치 current·속도 velocity(px/초)를 목표 target 쪽으로 dt(초)만큼 진행한다.
   널리 쓰이는 게임 엔진 식(Unity SmoothDamp 와 같은 근사)이라 프레임 간격이 달라도 같은 움직임이 나온다. 목표를 지나치면 목표에 세운다. */
const springStep = (current, target, velocity, dt) => {
  const omega = 2 / SCROLL_SMOOTH_TIME_S;
  const x = omega * dt;
  const decay = 1 / (1 + x + 0.48 * x * x + 0.235 * x * x * x);
  const change = current - target;
  const temp = (velocity + omega * change) * dt;
  const next = target + (change + temp) * decay;
  if ((target - current > 0) === (next > target)) return { pos: target, vel: 0 };   // 넘침 방지
  return { pos: next, vel: (velocity - omega * temp) * decay };
};
/* 진행 시계 — 매 프레임 흐른 시간을 0~MAX_FRAME_STEP_MS 로 묶어 더한다(첫 프레임은 한 프레임 분량으로 시작해 역방향·건너뜀이 없다) */
const makeClock = () => {
  let last = null; let elapsed = 0;
  return (now) => {
    const dt = last === null ? 16 : Math.min(MAX_FRAME_STEP_MS, Math.max(0, now - last));
    last = now; elapsed += dt;
    return elapsed;
  };
};

/* 캐릭터 그림 실패 처리 — 대체 그림(fallback: webp 가 없을 때 png)이 있으면 한 번 바꾸고, 그것도 없으면 숨긴다 */
const onChrError = (e, chr) => {
  const el = e.currentTarget;
  if (chr && chr.fallback && el.dataset.fallback !== '1') {
    el.dataset.fallback = '1';
    el.src = chr.fallback;
    return;
  }
  el.style.display = 'none';
};

const HeroTrain = ({ cards, activeIndex, onActivate, actions, headline, headlineStyle }) => {
  const pinRef = useRef(null);
  const heroRef = useRef(null);
  const h1Ref = useRef(null);
  const trainRef = useRef(null);
  const cardRefs = useRef([]);
  /* 기하 상태는 렌더와 무관한 값이라 ref 에 둔다(매 프레임 setState 금지) */
  /* smoothY·smoothV = 카드 줄이 따라가고 있는 스크롤 위치와 그 속도(px/초) — 실제 스크롤을 스프링으로 뒤따르는 값 */
  const geo = useRef({ samples: [], totalLen: 0, pinOffset: 0, pinLen: 0, scrollSlots: 0, introOffset: 0, indexOffset: 0, smoothY: 0, smoothV: 0 });
  const rafRef = useRef({ follow: 0, intro: 0, index: 0, idle: 0, idleTimer: 0 });
  const layoutFnRef = useRef(null);
  /* 입장 동작을 이미 재생했는지 — 한 번만 재생한다(①) */
  const introDoneRef = useRef(false);
  const count = cards.length;
  /* 큰 제목은 카드와 따로 — 두 줄 중 하나라도 글자가 있을 때만 그린다(비우면 제목 없이 카드만) */
  const line1 = (headline && typeof headline.line1 === 'string') ? headline.line1.trim() : '';
  const line2 = (headline && typeof headline.line2 === 'string') ? headline.line2.trim() : '';
  const hasHeadline = !!(line1 || line2);
  const headlineLen = line1.length + line2.length;

  /* 경로·고정 구간·스크롤 스크럽 — 카드 수가 바뀌면 다시 세운다(입장 동작은 다시 틀지 않는다). 언마운트 시 리스너·rAF 전부 해제 */
  useEffect(() => {
    if (!count) return undefined;
    const g = geo.current;
    const raf = rafRef.current;
    const reduce = prefersReducedMotion();
    const root = document.documentElement;
    const setK = () => root.style.setProperty('--k', kf().toFixed(4));

    const buildPath = () => {
      const k = kf(); const sx = (HERO.SVGW / HERO.VBW) * k; const sy = k; const P = HERO.P;
      let prev = null; let len = 0; const samples = [];
      for (let i = 0; i <= 800; i++) {
        const t = i / 800; const mt = 1 - t;
        const x = (mt * mt * mt * P[0][0] + 3 * mt * mt * t * P[1][0] + 3 * mt * t * t * P[2][0] + t * t * t * P[3][0]) * sx;
        const y = (mt * mt * mt * P[0][1] + 3 * mt * mt * t * P[1][1] + 3 * mt * t * t * P[2][1] + t * t * t * P[3][1]) * sy;
        if (prev) len += Math.hypot(x - prev.x, y - prev.y);
        samples.push({ x, y, len }); prev = { x, y };
      }
      g.samples = samples; g.totalLen = len;
    };
    const pointAt = (sRaw) => {
      const s = Math.max(0, Math.min(g.totalLen, sRaw));
      const samples = g.samples;
      let lo = 0; let hi = samples.length - 1;
      while (lo < hi) { const mid = (lo + hi) >> 1; if (samples[mid].len < s) lo = mid + 1; else hi = mid; }
      const b = samples[lo]; const a = samples[Math.max(0, lo - 1)]; const seg = (b.len - a.len) || 1; const f = (s - a.len) / seg;
      return { x: a.x + (b.x - a.x) * f, y: a.y + (b.y - a.y) * f, ang: (Math.atan2(b.y - a.y, b.x - a.x) * 180) / Math.PI };
    };
    /* 카드 배치: 칸(slot) = 카드 번호 − 현재 장(이벤트 카드 누름) − 스크롤 전진 + 입장 오프셋 */
    const layoutHero = () => {
      const k = kf(); const ox = 228 * k; const oy = 108.8 * k; const cx = (HERO.SVGW * k) / 2;
      cardRefs.current.forEach((el, i) => {
        if (!el) return;
        const slot = i - g.indexOffset - g.scrollSlots + g.introOffset;
        const p = pointAt(g.totalLen * (HERO.START + HERO.STEP * slot));
        el.style.transform = `translate(${((p.x - cx) - ox).toFixed(1)}px,${(p.y - oy).toFixed(1)}px) rotate(${p.ang.toFixed(2)}deg)`;
        el.style.zIndex = String(50 - Math.round(Math.abs(slot)));
      });
    };
    const measureHero = () => {
      const hero = heroRef.current; const pin = pinRef.current;
      if (!hero || !pin) return;
      const heroH = hero.offsetHeight;
      g.pinOffset = Math.max(0, heroH - window.innerHeight);   // 시안: 히어로 상단이 화면 위로 나갈 만큼 스크롤된 뒤 고정 시작
      g.pinLen = Math.round(window.innerHeight * 0.5);          // 고정 구간 = 뷰포트 높이의 절반
      pin.style.height = `${heroH + g.pinLen}px`;
      hero.style.top = `${-g.pinOffset}px`;
    };
    /* 스크롤 위치 y 에 맞춰 헤드라인·카드를 놓는다(y = 따라가는 값 smoothY) */
    const applyScroll = (y) => {
      const q = Math.min(1, y / Math.max(1, g.pinOffset + g.pinLen));
      const h1 = h1Ref.current;
      if (h1) {
        h1.style.opacity = (1 - q).toFixed(3);
        h1.style.transform = `translateY(${(-50 * q).toFixed(1)}px) scale(${(1 + 0.5 * q).toFixed(3)})`;
      }
      const p = Math.min(1, Math.max(0, (y - g.pinOffset) / Math.max(1, g.pinLen)));
      g.scrollSlots = HERO.ADVANCE * p;
      layoutHero();
    };
    /* 따라갈 목표 = 실제 스크롤 위치를 고정 구간 끝까지로 묶은 값. 그 아래로는 제목·카드가 더 변하지 않으므로,
       페이지 아래에서 다시 올라올 때 먼 거리를 되짚느라 카드가 늦게 반응하지 않는다 */
    const followTarget = () => Math.min(g.pinOffset + g.pinLen, Math.max(0, window.scrollY));
    /* 따라가기 한 걸음 — 흐른 시간만큼 스프링을 진행한다(시간 기준이라 60·120Hz 화면에서 같은 움직임).
       속도(g.smoothV)는 걸음 사이에 이어져, 휠을 연달아 굴려도 속도가 끊기지 않고 부드럽게 붙는다.
       한 프레임 시간은 MAX_FRAME_STEP_MS 로 묶어 화면 갱신이 멈췄다 풀려도 한 번에 건너뛰지 않는다 */
    let lastFollowAt = null;
    const followStep = (now) => {
      const target = followTarget();
      const dtMs = lastFollowAt === null ? 16 : Math.min(MAX_FRAME_STEP_MS, Math.max(0, now - lastFollowAt));
      lastFollowAt = now;
      if (Math.abs(target - g.smoothY) <= SCROLL_SETTLE_PX && Math.abs(g.smoothV) <= SCROLL_SETTLE_SPEED) {
        g.smoothY = target; g.smoothV = 0; applyScroll(g.smoothY);
        raf.follow = 0; lastFollowAt = null;   // 도착 — 다음 스크롤까지 쉰다
        return;
      }
      const s = springStep(g.smoothY, target, g.smoothV, dtMs / 1000);
      g.smoothY = s.pos; g.smoothV = s.vel;
      applyScroll(g.smoothY);
      raf.follow = requestAnimationFrame(followStep);
    };
    /* 스크롤이 바뀌면 따라가기를 시작한다(이미 따라가는 중이면 그대로 — 목표는 매 프레임 새로 읽는다).
       움직임 최소화 설정이면 따라가기 없이 바로 그 자리에 놓는다 */
    const heroScroll = () => {
      if (reduce) { g.smoothY = followTarget(); g.smoothV = 0; applyScroll(g.smoothY); return; }
      if (!raf.follow) raf.follow = requestAnimationFrame(followStep);
    };
    /* 첫 진입: 카드가 오른쪽에서 1.4칸 밀려 들어온다 — 한 번만(①). 움직임 최소화 설정이면 즉시 제자리 */
    const intro = () => {
      if (trainRef.current) trainRef.current.classList.add('ready');
      if (reduce || introDoneRef.current) { g.introOffset = 0; layoutHero(); return; }
      introDoneRef.current = true;
      const clock = makeClock(); const D = INTRO_MS; const from = 1.4;
      const step = (now) => {
        /* 진행률 = 묶인 진행 시계 ÷ 길이, 0~1. 첫 프레임 시각이 시작보다 앞서 음수가 되던 역방향 튐(실측 +47px→−54px)과
           멈춤 뒤 순간이동(실측 한 프레임 180px)을 함께 막는다 */
        const u = Math.min(1, clock(now) / D); const e = 1 - Math.pow(1 - u, 3);
        g.introOffset = from * (1 - e); layoutHero();
        if (u < 1) raf.intro = requestAnimationFrame(step);
      };
      raf.intro = requestAnimationFrame(step);
    };

    /* 입장 동작을 이미 재생했으면(카드 수가 바뀌어 다시 세우는 경우) 오프셋 없이 제자리에서 다시 배치한다 */
    g.introOffset = (reduce || introDoneRef.current) ? 0 : 1.4;
    layoutFnRef.current = layoutHero;
    /* 스크롤 = 따라가기 시작만 한다(그리기는 따라가기 걸음이 한 프레임에 한 번) */
    const onScroll = () => heroScroll();
    /* 크기·기하가 바뀌면 지금 따라가던 위치에서 새 기하로 다시 놓고, 목표가 달라졌으면 이어서 따라간다 */
    const onResize = () => { setK(); buildPath(); measureHero(); applyScroll(g.smoothY); heroScroll(); };
    const remeasure = () => { measureHero(); applyScroll(g.smoothY); heroScroll(); };
    /* 입장 동작은 페이지가 한가해진 뒤에 시작한다 — 카드 줄과 같은 순간에 게임사 목록 등 아래 구역이 한꺼번에 그려지며
       화면 갱신이 200~290ms 멈췄고(실측), 그 사이 입장 동작이 한 프레임에 180px 건너뛰었다. 카드 줄은 시작 전까지 보이지 않는다(.train 불투명 0). */
    const startIntroWhenIdle = () => {
      if (typeof window.requestIdleCallback === 'function') raf.idle = window.requestIdleCallback(() => intro(), { timeout: INTRO_IDLE_WAIT_MS });
      else raf.idleTimer = setTimeout(intro, 200);
    };
    const onLoad = () => { remeasure(); startIntroWhenIdle(); };

    /* 처음 그릴 때는 지금 스크롤 위치에 바로 놓는다(따라가기 없이 — 새로고침·되돌아오기 때 카드가 미끄러져 오지 않게) */
    setK(); buildPath(); measureHero(); g.smoothY = followTarget(); g.smoothV = 0; applyScroll(g.smoothY);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    /* 액션 줄 줄바꿈·헤드라인 길이로 히어로 높이가 바뀌면 고정 구간을 다시 잰다 */
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(remeasure) : null;
    if (ro && heroRef.current) ro.observe(heroRef.current);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
    if (document.readyState === 'complete') onLoad(); else window.addEventListener('load', onLoad);

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('load', onLoad);
      if (ro) ro.disconnect();
      /* 따라가기 번호를 0 으로 되돌린다 — rafRef 는 다시 세울 때도 이어지므로, 남아 있으면 새 판에서 따라가기가 시작되지 않는다 */
      cancelAnimationFrame(raf.follow); raf.follow = 0;
      cancelAnimationFrame(raf.intro);
      cancelAnimationFrame(raf.index);
      if (raf.idle && typeof window.cancelIdleCallback === 'function') window.cancelIdleCallback(raf.idle);
      if (raf.idleTimer) clearTimeout(raf.idleTimer);
      layoutFnRef.current = null;
      root.style.removeProperty('--k');
    };
  }, [count]);

  /* 현재 장이 바뀌면(이벤트 카드를 누르면) 열차를 그 칸만큼 부드럽게 민다 — 가속·감속 곡선(③) */
  useEffect(() => {
    const g = geo.current; const raf = rafRef.current; const layout = layoutFnRef.current;
    if (!layout) return undefined;
    cancelAnimationFrame(raf.index);
    if (prefersReducedMotion()) { g.indexOffset = activeIndex; layout(); return undefined; }
    const from = g.indexOffset; const to = activeIndex; const clock = makeClock();
    if (from === to) { layout(); return undefined; }
    const step = (now) => {
      const u = Math.min(1, clock(now) / MOVE_MS); const e = easeInOutCubic(u); // 묶인 진행 시계(역방향 튐·순간이동 방지)
      g.indexOffset = from + (to - from) * e; layout();
      if (u < 1) raf.index = requestAnimationFrame(step);
    };
    raf.index = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf.index);
  }, [activeIndex, count]);

  return (
    <div className="hero-pin" ref={pinRef} data-block="black-hero">
      <section className={`hero${count ? '' : ' hero--no-train'}`} ref={heroRef} id="hero">
        {actions}
        {hasHeadline && (
          /* 큰 제목 = 루미나 전용 '첫 화면 제목'(디자인설정). 글꼴·굵기·색은 CSS 변수(--hero-heading-*)로 받는다(부모가 넘긴 headlineStyle). */
          <div className="container">
            {/* 문구 길이 단계: 12자 초과 = long(80px), 24자 초과 = xlong(56px) — 긴 문장이 140px 대문자 스케일로 화면을 덮는 것을 막는다(관리자 글자 크기 설정값이 있으면 그 값이 우선) */}
            <h1 className={"heading-1" + (headlineLen > 24 ? " hl-xlong" : headlineLen > 12 ? " hl-long" : "")} ref={h1Ref} style={headlineStyle}>
              {line1}
              {line2 && <span className="line-2">{line2}</span>}
            </h1>
          </div>
        )}
        {/* [2026-09-29 운영자 지시] 카드 줄 아래 이전/다음 화살표·점 줄은 없앴다 — 카드 줄만 그린다 */}
        {count > 0 && (
          <div className="train" ref={trainRef}>
            {cards.map((card, i) => {
              /* 누르면 부모가 정한 동작(이벤트 = 그 칸으로 이동 / 게임 = 실행 / 게임사 = 게임 목록·로비) */
              const activate = () => onActivate(card, i);
              return (
                <div
                  key={card.key}
                  className={`ccard group ccard--${card.kind}${i === activeIndex ? ' is-active' : ''}`}
                  role="button"
                  tabIndex={0}
                  aria-label={card.title || `카드 ${i + 1}`}
                  ref={(el) => { cardRefs.current[i] = el; }}
                  onClick={activate}
                  onKeyDown={onEnterOrSpace(activate)}
                >
                  {/* 캐릭터 그림(관리자가 올린 캐릭터 또는 게임사 캐릭터)은 시안처럼 틀 위로 튀어나온다 */}
                  {card.chr && (
                    <img className="chr" src={card.chr.src} alt="" onError={(e) => onChrError(e, card.chr)} />
                  )}
                  <div className="frame">
                    {/* 배경 = 관리자가 올린 그림(이벤트·바꾼 그림) 또는 게임 그림. 없으면 카드 기본 바탕(남색)만 보인다 */}
                    {card.bg && (card.bg.video ? (
                      <video className="bg" src={card.bg.src} autoPlay muted loop playsInline />
                    ) : (
                      <img className="bg" src={card.bg.src} alt="" onError={onThumbError} />
                    ))}
                    <div className="ov"></div>
                    <div className="bar">
                      <div className="ttl">{card.title}</div>
                      <IconBtn />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
};

export default HeroTrain;
